import React, { useState } from 'react';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);

  const subjectOptions = [
    { value: 'product', label: 'Informasi Produk Motor' },
    { value: 'service', label: 'Layanan Service & Perawatan' },
    { value: 'sparepart', label: 'Suku Cadang & Aksesoris' },
    { value: 'credit', label: 'Simulasi Kredit & Pembiayaan' },
    { value: 'complaint', label: 'Keluhan & Saran' },
    { value: 'other', label: 'Lainnya' },
  ];

  const handleChange = (e) => {
    const { name, value } = e?.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (errors?.[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const handleSelectChange = (value) => {
    setFormData(prev => ({ ...prev, subject: value }));
    if (errors?.subject) {
      setErrors(prev => ({ ...prev, subject: '' }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData?.name?.trim()) {
      newErrors.name = 'Nama lengkap wajib diisi';
    }

    if (!formData?.email?.trim()) {
      newErrors.email = 'Email wajib diisi';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/?.test(formData?.email)) {
      newErrors.email = 'Format email tidak valid';
    }

    if (!formData?.phone?.trim()) {
      newErrors.phone = 'Nomor telepon wajib diisi';
    } else if (!/^[0-9]{10,13}$/?.test(formData?.phone?.replace(/[\s-]/g, ''))) {
      newErrors.phone = 'Nomor telepon tidak valid (10-13 digit)';
    }

    if (!formData?.subject) {
      newErrors.subject = 'Pilih subjek pertanyaan';
    }

    if (!formData?.message?.trim()) {
      newErrors.message = 'Pesan wajib diisi';
    } else if (formData?.message?.trim()?.length < 10) {
      newErrors.message = 'Pesan minimal 10 karakter';
    }

    return newErrors;
  };

  const formatWhatsAppMessage = () => {
  const subjectLabel =
    subjectOptions.find(opt => opt.value === formData.subject)?.label || '-';

      return `
    Halo Honda Pamulang 👋

    Saya ingin bertanya dengan detail berikut:

    Nama: ${formData.name}
    Email: ${formData.email}
    No. HP: ${formData.phone}
    Subjek: ${subjectLabel}

    Pesan:
    ${formData.message}
      `.trim();
  };


  const handleSubmit = (e) => {
    e.preventDefault();

    const newErrors = validateForm();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setIsSubmitting(true);

    const phoneNumber = '6288293642972'; // 🔥 GANTI ke nomor WA tujuan
    const message = formatWhatsAppMessage();
    const encodedMessage = encodeURIComponent(message);

    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

    // buka WhatsApp
    window.open(whatsappUrl, '_blank');

    // UI feedback (opsional, tapi UX lu bagus jadi keep)
    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitSuccess(true);
      setFormData({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: '',
      });

      setTimeout(() => {
        setSubmitSuccess(false);
      }, 5000);
    }, 800);
  };


  return (
    <section className="py-12 md:py-16 lg:py-20 bg-muted">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-8 md:mb-12"data-aos="fade-up" data-aos-delay="150">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground mb-3 md:mb-4">
              Kirim Pesan
            </h2>
            <p className="text-sm md:text-base lg:text-lg text-muted-foreground">
              Isi formulir di bawah ini dan tim kami akan segera menghubungi Anda
            </p>
          </div>

          <div className="bg-card rounded-2xl shadow-card-hover p-6 md:p-8 lg:p-10" data-aos="fade-down" data-aos-delay="150">
            {submitSuccess && (
              <div className="mb-6 md:mb-8 p-4 md:p-6 bg-green-50 border border-green-200 rounded-lg flex items-start space-x-3">
                <Icon name="CheckCircle" size={24} color="#00B04F" className="flex-shrink-0 mt-0.5" />
                <div>
                  <h4 className="text-base md:text-lg font-heading font-semibold text-green-800 mb-1">
                    Pesan Terkirim!
                  </h4>
                  <p className="text-sm md:text-base text-green-700">
                    Terima kasih telah menghubungi kami. Tim Honda Pamulang akan segera merespons pesan Anda dalam 1x24 jam.
                  </p>
                </div>
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-4 md:space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
                <Input
                  label="Nama Lengkap"
                  type="text"
                  name="name"
                  placeholder="Masukkan nama lengkap Anda"
                  value={formData?.name}
                  onChange={handleChange}
                  error={errors?.name}
                  required
                />

                <Input
                  label="Email"
                  type="email"
                  name="email"
                  placeholder="contoh@email.com"
                  value={formData?.email}
                  onChange={handleChange}
                  error={errors?.email}
                  required
                />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
                <Input
                  label="Nomor Telepon"
                  type="tel"
                  name="phone"
                  placeholder="08123456789"
                  value={formData?.phone}
                  onChange={handleChange}
                  error={errors?.phone}
                  required
                />

                <Select
                  label="Subjek Pertanyaan"
                  placeholder="Pilih subjek"
                  options={subjectOptions}
                  value={formData?.subject}
                  onChange={handleSelectChange}
                  error={errors?.subject}
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-foreground mb-2">
                  Pesan <span className="text-primary">*</span>
                </label>
                <textarea
                  name="message"
                  rows={6}
                  placeholder="Tuliskan pesan atau pertanyaan Anda di sini..."
                  value={formData?.message}
                  onChange={handleChange}
                  className={`w-full px-4 py-3 rounded-lg border ${
                    errors?.message ? 'border-error' : 'border-border'
                  } bg-background text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all duration-200 resize-none`}
                />
                {errors?.message && (
                  <p className="mt-2 text-sm text-error">{errors?.message}</p>
                )}
              </div>

              <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-4" data-aos="fade-right" data-aos-delay="150">
                <p className="text-xs md:text-sm text-muted-foreground">
                  <span className="text-primary">*</span> Wajib diisi
                </p>

                <Button
                  type="submit"
                  variant="default"
                  size="lg"
                  loading={isSubmitting}
                  iconName="Send"
                  iconPosition="right"
                  className="w-full sm:w-auto"
                  data-aos="fade-left" data-aos-delay="200"
                >
                  {isSubmitting ? 'Mengirim...' : 'Kirim Pesan'}
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;